import {ActionTree, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {User, Company} from '@/store/modules/lib'
import axios from 'axios';
import VueI18n from '../../helpers/i18n';
import api from "@/service/api";
import any = jasmine.any;
import _ from "lodash";

export interface State {
    user: User | null;
    userCompanies: Company[] | null;
    currentWorkspace: string;
    currentCompany: Company | null;
    companyProfile: CompanyProfile | null;
    loadingProfile: boolean;
    loadingEmployees: boolean;
    employeesCompany: any;
    inviteEmployeesCompany: any;
    companyInfo: any;
    userInvites: any;
    isExistCompany: boolean;
}

export interface CompanyProfile {
    companyTitle: string;
    contacts?: any
    description?: any;
    locations?: any;
    taxId?: any;
}

const defaultState: State = {
    user: null,
    userCompanies: null,
    currentWorkspace: 'personal',
    currentCompany: null,
    companyProfile: {
        companyTitle: '',
        description: '',
        taxId: '',
        contacts: [],
        locations: [],
    },
    inviteEmployeesCompany: [],
    loadingProfile: false,
    loadingEmployees: false,
    employeesCompany: null,
    companyInfo: {},
    userInvites: null,
    isExistCompany: false,
};


const getters = {
    getInviteEmployeesCompany: (state: State) => state.inviteEmployeesCompany,
    getEmployeesCompany: (state: State) => state.employeesCompany,
    getLoadingProfile: (state: State) => state.loadingProfile,
    getLoadingEmployees: (state: State) => state.loadingEmployees,
    getCompanyProfile: (state: State) => state.companyProfile,
    getCompanyProfileRaf: (state: State) => state.companyProfile,
    getCurrentCompany: (state: State) => {
        if (state.currentWorkspace != 'personal' && state.userCompanies) {
            return state.userCompanies.filter((company: any) => {
                return company.company.code == state.currentWorkspace
            })[0]
        } else {
            return null
        }
    },
    getCurrentWorkspace: (state: State) => state.currentWorkspace,
    getUser: (state: State) => state.user,
    userCompanies: (state: State) => state.userCompanies,
    getCompanyInfo: (state: State) => state.companyInfo,
    getUserInvites: (state: State) => state.userInvites,
    getIsExistCompany: (state: State) => state.isExistCompany
}
const mutations: MutationTree<State> = {

    deleteEmployeesCompany(state: State, payload: any) {
        state.employeesCompany = state.employeesCompany.filter((el: any) => {
            return el._id !== payload._id
        })
    },
    patchEmployeesCompany(state: State, payload: any) {
        try {
            state.employeesCompany.map(
                (member: any) => {
                    if (member._id === payload._id) {
                        return {
                            // createdAt: payload.metadata.createdAt || null,
                            // updatedAt: payload.metadata.updatedAt || null,
                            role: 'standman',
                            // status: payload.status || null,
                            firstName: payload.user.firstName,
                            lastName: payload.user.lastName,
                            login: payload.user.login,
                            _id: payload._id,
                            insideStatus: 'member',
                            statusRole: true
                        }
                    }
                })
        } catch (e) {
            console.log('err')
        }


    },
    deleteInviteEmployeesCompany(state: State, payload: any) {
        state.employeesCompany = state.employeesCompany.filter((el: any) => {
            return el._id !== payload
        })
    },
    refreshCompanyProfile(state: State) {
        const help = JSON.parse(JSON.stringify(state.companyProfile))
        state.companyProfile = null
        state.companyProfile = help
    },
    addInviteEmployeesCompany(state: State, payload: any) {
        payload.forEach((el: any) => {
            state.employeesCompany.push(el)
        })
    },
    setInviteEmployeesCompany(state: State, payload: any) {
        payload.forEach((el: any) => {
            state.employeesCompany.push(el)
        })
    },
    setEmployeesCompany(state: State, payload: any) {
        state.employeesCompany = payload
    },
    setCompanyProfile(state: State, payload: any) {
        state.companyProfile = payload
        console.log(payload)
        if (state.userCompanies) {
            state.userCompanies.map((el: any) => {
                if (el.company.code == payload.code) {
                    el.company.logoKey = payload.logoKey
                }
            })
        }


    },
    clear(state: State) {
        state.user = null
        state.userCompanies = null
        state.currentCompany = null
    },
    setCurrentWorkspace(state: State, payload) {
        state.currentWorkspace = payload
    },
    setUser(state: State, payload: User) {
        state.user = payload
    },
    setUserCompanies(state: State, payload: Company[]) {
        state.userCompanies = payload
    },
    addUserCompanies(state: State, payload: any) {
        let company = {role: "owner", company: {title: payload.companyTitle, code: payload.code}}
        state.userCompanies ? state.userCompanies.push(company) : state.userCompanies = [company]
    },
    setCompanyInfo(state: State, payload: any) {
        state.companyInfo = payload
    },
    setUserInvites(state: State, payload: any) {
        if (payload) {
            payload = payload.map((invite: any) => {
                return {
                    company: invite.company,
                    role: invite.companyRole
                }
            })
        }
        state.userInvites = payload
    },
    setIsExistCompany(state: State, payload: boolean) {
        state.isExistCompany = payload
    },
    updateUserInvites(state: State, payload: any) {
        state.userInvites = state.userInvites.filter((invite: any) => invite.company.code != payload.company.code)
    },
    updateUserCompanies(state: State, payload: any) {
        state.userCompanies ? state.userCompanies.push(payload) : state.userCompanies = payload
    },
};

const actions: ActionTree<State, RootState> = {
    async saveProfileCompanyByServer({commit, state}, payload: any) {
        try {
            const {data} = await api.go('saveProfileCompanyByServer', {
                params: payload.params,
                body: payload.body
            })
            commit('setCompanyProfile', data.data)
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.some_notification.data_save')]
            })
        } catch (e) {

        } finally {

        }
    },
    async getProfileCompanyFromServer({commit, state}, payload: any) {
        try {
            state.loadingProfile = true
            const {data} = await api.go('getProfileCompanyFromServer', {
                params: {
                    CompanyCode: payload
                },
                query: {
                    status: 'active'
                }
            })
            commit('setCompanyProfile', data.data.company)
            state.loadingProfile = true
        } catch (e) {
            state.loadingProfile = true
        } finally {
            state.loadingProfile = true
        }
    },
    async getEmployeesCompanyFromServer({commit, state}, payload: any) {
        try {
            const {data} = await api.go('getEmployeesCompanyFromServer', {
                params: {
                    CompanyCode: payload
                }
            })
            const help = [
                ...data.data.companyMembers.filter((el: any) => el.role == 'owner'),
                ...data.data.companyMembers.filter((el: any) => el.role == 'marketer'),
                ...data.data.companyMembers.filter((el: any) => el.role == 'support'),
                ...data.data.companyMembers.filter((el: any) => el.role == 'standman'),
            ].map((member: any) => {
                return {
                    createdAt: member.metadata.createdAt,
                    updatedAt: member.metadata.updatedAt,
                    role: member.role,
                    status: member.status,
                    firstName: member.user.firstName,
                    lastName: member.user.lastName,
                    login: member.user.login,
                    _id: member._id,
                    insideStatus: 'member',
                    statusRole: true
                }
            })

            commit('setEmployeesCompany', help)
        } catch (e) {
        } finally {
        }
    },
    async getInviteCompanyFromServer({commit, state}, payload: any) {
        try {
            const {data} = await api.go('getInviteCompanyFromServer', {
                params: {
                    CompanyCode: payload
                },
                query: {
                    status: 'active'
                }
            })

            const help = data.data.invites.map((invite: any) => {
                return {
                    createdAt: invite.metadata.createdAt,
                    updatedAt: invite.metadata.updatedAt,
                    role: invite.companyRole,
                    status: invite.status,
                    firstName: invite.name,
                    lastName: invite.surname,
                    login: invite.phone,
                    _id: invite._id,
                    insideStatus: 'invite'
                }
            })

            commit('setInviteEmployeesCompany', help)
        } catch (e) {
        } finally {
        }
    },
    async addInviteEmployeesCompany({commit, state}, payload: any) {
        try {
            const {data} = await api.go('addInviteEmployeesCompany', {
                params: payload.params,
                body: payload.body
            })
            const help = data.data.invites.map((invite: any) => {
                return {
                    createdAt: invite.metadata.createdAt,
                    updatedAt: invite.metadata.updatedAt,
                    role: invite.companyRole,
                    status: invite.status,
                    firstName: invite.name,
                    lastName: invite.surname,
                    login: invite.phone,
                    _id: invite._id,
                    insideStatus: 'invite'
                }
            })
            commit('addInviteEmployeesCompany', help)
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('mailing.status.save')]

            })

        } catch (e) {
            this.commit('dialog/SetModalError',
                {
                    show: true,
                    modalErrorTitle: VueI18n.t('error.members.add_title')
                }
            )
        } finally {

        }
    },
    async pathEmployeesCompanyFromServer({commit, state}, payload: any) {
        const role = state.employeesCompany.filter((member: any) => member._id == payload.params.memberId)[0].role
        if (role === payload.body.role) return
        try {

            state.employeesCompany.filter((member: any) => member._id == payload.params.memberId)[0].statusRole = false
            const {data} = await api.go('pathEmployeesCompanyFromServer', {
                params: payload.params,
                body: payload.body
            })
            commit('patchEmployeesCompany', data.data.companyMember)

            state.employeesCompany.filter((member: any) => member._id == payload.params.memberId)[0].statusRole = true
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.some_notification.data_save')]
            })

        } catch (e) {
            this.commit('dialog/SetModalError', {show: true, error: 'someError'})
            state.employeesCompany.filter((member: any) => member._id == payload.params.memberId)[0].role = role
        } finally {
            state.employeesCompany.filter((member: any) => member._id == payload.params.memberId)[0].statusRole = true
        }
    },
    async deleteEmployeesCompanyFromServer({commit, state}, payload: any) {
        try {
            const {data} = await api.go('deleteEmployeesCompanyFromServer', {
                params: payload.params,
                body: payload.body
            })
            commit('deleteEmployeesCompany', data.data.companyMember)

            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.some_notification.data_save')]
            })

        } catch (e) {
            this.commit('dialog/SetModalError',
                {
                    show: true,
                    modalErrorTitle: VueI18n.t('error.members.delete_title')
                })
        }
    },
    async refreshInviteEmployeesCompany({commit, state}, payload: any) {
        try {
            const {data} = await api.go('addInviteEmployeesCompany', {
                params: payload.params,
                body: payload.body
            })
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.some_notification.data_save')]
            })

        } catch (e) {

        } finally {

        }
    },
    async deleteInviteEmployeesCompany({commit, state}, payload: any) {
        try {
            const {data} = await api.go('deleteInviteEmployeesCompany', {
                params: {
                    memberId: payload
                }
            })
            commit('deleteInviteEmployeesCompany', payload)
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.some_notification.data_save')]
            })

        } catch (e) {

        } finally {

        }
    },
    async getCompanyFromServer({commit}, payload: string) {
        try {
            const {data} = await api.go('getCompanies')
            commit('setUserCompanies', data.data)
        } catch (e) {
            console.log(e)
        }
    },
    async checkExistCompany({commit}, payload: any) {
        try {
            const {data} = await api.go('checkExistCompany', {params: payload})
            commit('setIsExistCompany', data.data != null)
        } catch (e) {
            console.log(e)
        }
    },
    async getUserFromServer({state, commit}, payload: string) {
        try {
            const {data} = await api.go('getUser')
            commit('setUser', data.data.user)
        } catch (e) {
            console.log(e)
        }
    },
    async addCompany({commit, state}, payload) {
        try {
            const {data} = await api.go('addCompany', {body: payload})
            commit('addUserCompanies', data.data)
            this.commit('dialog/SetFullDialogShow', false)
        } catch (e) {
            console.log(e)
        }
    },
    async sendInvite({commit, state}, payload) {
        try {
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('workspace.create_company.standman.alert')]
            })
            const {data} = await api.go('inviteOwner', {body: payload})
        } catch (e) {
        }
    },
    async getCompanyInfoFromServer({commit, state}, payload) {
        try {
            const {data} = await api.go('getCompanyInfo', {params: payload})
            commit('setCompanyInfo', data.data.showCompanyParticipant)
        } catch (e) {
        }
    },
    async saveCompanyInfo({commit, state}, payload) {
        try {
            const {data} = await api.go('saveCompanyInfo', {params: payload.params, body: payload.body})
            commit('setCompanyInfo', data.data.showCompanyParticipant)
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.some_notification.data_save')]
            })
        } catch (e) {
        }
    },
    async patchProfileUser({commit, state}, payload) {
        try {
            const {data} = await api.go('patchProfileUser', payload)
            commit('setUser', data.data.user)
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.some_notification.data_save')]
            })
        } catch (e) {
        }
    },
    async getUserInvitesFromServer({commit, state}, payload) {
        try {
            if (state.userInvites === null) {
                const {data} = await api.go('getUserInvitesFromServer')
                commit('setUserInvites', data.data.invites)
            }
        } catch (e) {
        }
    },
    async rejectInviteFromServer({commit, state}, payload) {
        try {
            const {data} = await api.go('rejectInviteFromServer', {params: {CompanyCode: payload.company.code}})
            commit('updateUserInvites', payload)
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.some_notification.data_save')]
            })
        } catch (e) {
        }
    },
    async acceptInviteFromServer({commit, state}, payload) {
        try {
            const {data} = await api.go('acceptInviteFromServer', {params: {CompanyCode: payload.company.code}})
            commit('updateUserInvites', payload)
            commit('updateUserCompanies', payload)
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.some_notification.data_save')]
            })
        } catch (e) {
        }
    },
};

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions,
};
